import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { FullOffer } from 'app/shared/models/class/offer/offer';
import { FaiconService } from 'app/shared/services/faicon/faicon.service';
import { OfferService } from 'app/shared/services/offer/offer.service';

@Component({
  selector: 'app-session-booked-overview-session',
  templateUrl: './session-booked-overview-session.component.html',
  styleUrls: ['./session-booked-overview-session.component.scss']
})
export class SessionBookedOverviewSessionComponent implements OnInit, OnChanges {

  @Input() session: FullOffer;

  image: any = null;

  constructor(
    private offerService: OfferService,
    private domSanitizer: DomSanitizer,
    private faIconService: FaiconService,

  ) { }

  ngOnInit(): void { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.session) {
      this.getImage(changes.session.currentValue?.offerKey);
    }
  }

  getFaIcon(faIcon: string): string {
    return this.faIconService.getFaIcon(faIcon);
  }

  private getImage(offerKey: number) {
    if (offerKey) {
      this.offerService.getImgOffer(offerKey).subscribe({
        next: image => {
          if (image.pictureBase64) {
            this.image = this.domSanitizer.bypassSecurityTrustUrl(`data:image/png;base64, ${image.pictureBase64}`);
          } else {
            this.image = null;
          }
        }
      });
    }
  }

}
